(() => {
  'use strict';

  const initTestimonials = (scope = document) => {

    const sections = scope.querySelectorAll('.ecoma-testimonials');

    sections.forEach((section) => {

      const slider = section.querySelector('.testimonial-slider');

      if (!slider) return;

      if (slider.swiper) {
        slider.swiper.destroy(true, true);
      }


     new Swiper(slider, {

    slidesPerView: 1,

    spaceBetween: 20,

    speed: 700,

    loop: true,
    

    grabCursor: true,

    watchOverflow: true,

    observer: true,
    observeParents: true,

    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
    },

    navigation: {
        nextEl: section.querySelector('.testimonial-next'),
        prevEl: section.querySelector('.testimonial-prev')
    },

    breakpoints: {

       0: {
            slidesPerView: 1.3,
            spaceBetween: 16
        },

        768: {
            slidesPerView: 2,
            spaceBetween: 24
        },

        1024: {
            slidesPerView: 3,
            spaceBetween: 28
        },

        1400: {
            slidesPerView: 4,
            spaceBetween: 28
        }

    }

});

    

    });

  };

  document.addEventListener("DOMContentLoaded", function () {

    initTestimonials();

  });

  document.addEventListener("shopify:section:load", function (event) {

    initTestimonials(event.target);

  });

  document.addEventListener("shopify:section:reorder", function () {

    initTestimonials();

  });

})();